import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./theme.css";
import App from "./App";
import categoryReducer from "./state/categoryState";
import productReducer from "./state/productState";
import restaurantReducer from "./state/restaurantState";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import FirmLicenseGate from "./FirmLicenseGate";
import { StatsProvider } from "./context/StatsContext.jsx";

const store = configureStore({
  reducer: {
    products: productReducer,
    categories: categoryReducer,
    restaurants: restaurantReducer,
  },
});

const queryParams = new URLSearchParams(window.location.search);
const id = queryParams.get("id");
// const id = "MP226";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StatsProvider id={id}>
<FirmLicenseGate firmId={id}>
  <Provider store={store}>
    <App id={id} />
  </Provider>
  </FirmLicenseGate>
</StatsProvider>
);
